import { clientEntry } from "#src/entry-client.mjs";
import BareTheme from "#src/themes/bare/BareTheme.vue";
clientEntry(BareTheme);
